<mbs-modal [isCustomModal]="true"
           [showFooter]="true"
           title="{{ 'shared:computers.modals.deletePlanCaption' | i18next }}"
           #modal>
  <div modal-body>
    <mbs-alert *ngIf="error"
               [icon]="true"
               [type]="mbsPopupType.danger">
      <div>{{ error.message }}</div>
      <ul *ngIf="error.details"
          class="text-left m-0 p-2">
        <li *ngFor="let detail of error.details"
            class="ml-2 mb-1 pb-0">
          {{ detail }}
        </li>
      </ul>
    </mbs-alert>

    <mbs-alert *ngIf="!(permissionsEnum.DeleteDataFromStorage | can: 'read')"
               [icon]="true"
               [type]="mbsPopupType.warning">
      <div [innerHTML]="'shared:modals.delDataPermissionsRequiredAlert' | i18next"></div>
    </mbs-alert>

    <mbs-form-group>
      <h5 class="mt-0 mb-2">{{ 'shared:common.backupPlan' | i18next }}</h5>
      <div>{{ plan.displayName }}</div>
    </mbs-form-group>

    <mbs-form-group>
      <h5 class="mt-0 mb-2">{{ 'shared:computers.modals.deletionMode' | i18next }}</h5>

      <div>
        <mbs-radio [label]="'shared:computers.modals.deleteBackupPlanWithoutDataTitle' | i18next"
                   [value]="1"
                   [formControl]="deletionType">
          <ng-template radioDescription>
            <p class="mb-0 text-sm ml-4 pl-1">{{ 'shared:computers.modals.deleteBackupPlanWithoutDataDescription' | i18next }}</p>
          </ng-template>
        </mbs-radio>
      </div>

      <div [ngbTooltip]="!(permissionsEnum.DeleteDataFromStorage | can: 'read') ? ('shared:modals.delDataPermissionRequiredTooltip' | i18next) : ''"
           class="mb-2">
        <mbs-radio [label]="'shared:computers.modals.deleteBackupPlanWithDataTitle' | i18next"
                   [disabledSelf]="!(permissionsEnum.DeleteDataFromStorage | can: 'read')"
                   [class.cursor-not-allowed]="!(permissionsEnum.DeleteDataFromStorage | can: 'read')"
                   [value]="0"
                   [formControl]="deletionType">
          <ng-template radioDescription>
            <p class="mb-0 text-sm ml-4 pl-1"
               [class.text-gray-500]="!(permissionsEnum.DeleteDataFromStorage | can: 'read')">
              {{ 'shared:computers.modals.deleteBackupPlanWithDataDescription' | i18next }}
            </p>
          </ng-template>
        </mbs-radio>
      </div>
    </mbs-form-group>
  </div>
  <ng-container modalFooter>
    <mbs-button type="danger"
                [loading]="loading"
                (click)="onDeleteButtonClick()">
      {{ 'shared:buttons.delete' | i18next : { format: 'title' } }}
    </mbs-button>
    <mbs-button type="secondary"
                data-dismiss="modal"
                (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next : { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
